import GenericDB from './generic-db';

export default class ProgressReportsDB extends GenericDB {
  constructor() {
    super('progressReports');
  }
}
